<template>
  <div class="cute-timeline" :style="{ '--timeline-theme': timelineTheme }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Timeline',
  props: {
    timelineTheme: {
      type: String,
      default: '#5dbecb'
    }
  }
}
</script>

<style scoped>
.cute-timeline {
  padding: 10px 0;
  position: relative;
}
</style>
